var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("label", [_vm._v("Periodo")]),
      _c("datepicker", {
        class: [_vm.customWidth],
        attrs: {
          name: "period",
          language: _vm.es,
          "minimum-view": "month",
          "maximum-view": "month",
          "full-month-name": "",
          format: _vm.customFormatter,
          "disabled-dates": _vm.disabledDates
        },
        on: { selected: _vm.setDate },
        model: {
          value: _vm.period,
          callback: function($$v) {
            _vm.period = $$v
          },
          expression: "period"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }